import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import AboutHero from '../components/AboutHero';
import AboutWeCapture from '../components/AboutWeCapture';
import AboutFounder from '../components/AboutFounder';
import AboutTraining from '../components/AboutTraining';
import AboutTestimonials from '../components/AboutTestimonials';
import AboutTeam from '../components/AboutTeam';
import AboutTestimonialsCarousel from '../components/AboutTestimonialsCarousel';
import TrustedBy from '../components/TrustedBy';

const About = () => {
  const location = useLocation();

  useEffect(() => {
    // Only scroll to section if there's a hash in the URL
    if (location.hash) {
      const element = document.querySelector(location.hash);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    } else {
      // Scroll to top if no hash
      window.scrollTo(0, 0);
    }
  }, [location]);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main className=" md:pt-6">
        <div id="about-wetekup">
          <AboutHero />
        </div>
        <TrustedBy /> {/*don't change this position */}
        <div id="about-wecapture">
          <AboutWeCapture />
        </div>
        <div id="about-founder">
          <AboutFounder />
        </div>
        <AboutTraining />
        
          <AboutTestimonials />
        
        <div id="about-team">
          <AboutTeam />
        </div>
        <div id="testimonials">
        <AboutTestimonialsCarousel />
        </div>
        {/* Additional components will be added here */}
      </main>
      <Footer />
    </div>
  );
};

export default About;